import React from "react";
import { element, node, shape } from "prop-types";
import { components } from "react-select";
import styles from "./MenuList.module.css";
export var MenuList = function MenuList(props) {
  var children = props.children,
    _props$selectProps = props.selectProps,
    informationCell = _props$selectProps.informationCell,
    linkCell = _props$selectProps.linkCell;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(components.MenuList, props, informationCell && /*#__PURE__*/React.createElement("div", {
    className: styles["jds-MenuList__block"]
  }, informationCell), /*#__PURE__*/React.createElement("div", {
    className: styles["jds-MenuList__block"]
  }, children), linkCell && /*#__PURE__*/React.createElement("div", {
    className: styles["jds-MenuList__block"]
  }, linkCell)));
};
MenuList.propTypes = {
  children: node.isRequired,
  selectProps: shape({
    informationCell: element,
    linkCell: element
  }).isRequired
};